import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
class Draggable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      handle: props.handle,
      disabled: props.disabled,
      dragging: false
    };
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
  }
  componentDidMount() {
    var _a, _b;
    this.handleComponent = document.getElementById(this.state.handle);
    this.bodyComponent = document.getElementsByTagName("BODY")[0];
    this.dragComponent = document.getElementById("fmp-react-draggable");
    this.handleComponent.addEventListener("mousedown", this.onMouseDown);
    this.bodyComponent.addEventListener("mouseup", this.onMouseUp);
    this.bodyComponent.addEventListener("mouseleave", this.onMouseUp);
    this.bodyComponent.addEventListener("mousemove", this.onMouseMove);
    this.viewportWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    this.viewportHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    const initialBottomPos = this.props.positionBottom > this.viewportHeight - 500 ? this.viewportHeight - 500 : this.props.positionBottom;
    const initialRightPos = this.props.positionRight > this.viewportWidth - 350 ? this.viewportWidth - 350 : this.props.positionRight;
    const initialDefault = this.state.disabled ? 0 : 30;
    const initialDefaultRight = ((_a = this.props.defaultPosition) == null ? void 0 : _a.right) || initialDefault;
    const initialDefaultBottom = ((_b = this.props.defaultPosition) == null ? void 0 : _b.bottom) || initialDefault;
    this.dragComponent.style.bottom = (initialBottomPos || initialDefaultBottom) + "px";
    this.dragComponent.style.right = (initialRightPos || initialDefaultRight) + "px";
    window.addEventListener("resize", (event) => {
      this.viewportWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      this.viewportHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      );
      if (this.viewportHeight >= 500 && parseInt(this.dragComponent.style.bottom || 0, 10) > this.viewportHeight - 500) {
        this.dragComponent.style.bottom = this.viewportHeight - 500 + "px";
      }
      if (this.viewportWidth >= 350 && parseInt(this.dragComponent.style.right || 0, 10) > this.viewportWidth - 350) {
        this.dragComponent.style.right = this.viewportWidth - 350 + "px";
      }
    });
  }
  onMouseDown(event) {
    this.setState({
      dragging: true
    });
  }
  onMouseUp() {
    this.setState({
      dragging: false
    });
  }
  onMouseMove(event) {
    if (!this.prevY) {
      this.prevX = 0;
      this.prevY = 0;
    }
    let movementY = 0;
    let movementX = 0;
    if (typeof event.movementY === "undefined") {
      movementY = event.screenY - this.prevY;
      movementX = event.screenX - this.prevX;
      this.prevY = event.screenY;
      this.prevX = event.screenX;
    } else {
      movementY = event.movementY;
      movementX = event.movementX;
    }
    if (this.state.dragging === false) {
      return;
    }
    let newVerticalValue = (parseInt(this.dragComponent.style.bottom, 10) || 0) - movementY;
    let newHorizontalValue = (parseInt(this.dragComponent.style.right, 10) || 0) - movementX;
    if (newVerticalValue < 0) {
      newVerticalValue = 0;
    } else if (newVerticalValue > this.viewportHeight - 500) {
      newVerticalValue = this.viewportHeight - 500;
    }
    if (newHorizontalValue < 0) {
      newHorizontalValue = 0;
    } else if (newHorizontalValue > this.viewportWidth - 350) {
      newHorizontalValue = this.viewportWidth - 350;
    }
    this.dragComponent.style.bottom = newVerticalValue + "px";
    this.dragComponent.style.right = newHorizontalValue + "px";
    clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => {
      this.props.savePosition(
        parseInt(this.dragComponent.style.bottom, 10),
        parseInt(this.dragComponent.style.right, 10)
      );
    }, 100);
  }
  render() {
    return /* @__PURE__ */ jsx("div", { id: "fmp-react-draggable", style: { position: "fixed" }, children: this.props.children });
  }
}
Draggable.propTypes = {
  handle: PropTypes.string,
  disabled: PropTypes.bool,
  positionBottom: PropTypes.bool,
  positionRight: PropTypes.bool,
  children: PropTypes.node,
  savePosition: PropTypes.func,
  defaultPosition: PropTypes.shape({
    right: PropTypes.number,
    bottom: PropTypes.number
  })
};
export {
  Draggable as default
};
//# sourceMappingURL=Draggable.js.map
